import React from 'react';
import { Tooltip } from '@hpstellar/core';
import { Typography } from '@hpstellar/core/visId';

import { useMSRPProps } from '../../../../hooks/useProductPrice';

import './msrp-tooltip.less';

export default ({ children, productType, className, tooltipProps = {} }) => {
    const tootip = useMSRPProps();
    const { TooltipProps, buttonProps } = tootip;
    const { title, description } = TooltipProps || {};
    const { children: cta } = buttonProps || {};
    if (!description || productType === 'giftcard') {
        return children;
    }
    return (
        <>
            <Tooltip
                title={title}
                description={description}
                className="msrp-tooltip"
                activeOnFocus={true}
                activeOnHover={true}
                contentClassName="msrp-tooltip-content"
                {...tooltipProps}
            >
                <Typography
                    className={`msrp-tooltip-label${className ? ` ${className}` : ''}`}
                    variant="body1"
                    tag="button"
                    isCaps
                    underline
                >
                    {cta}
                </Typography>
            </Tooltip>
            {(!productType || productType.toLowerCase() !== 'cto') && children}
        </>
    );
};
